import React from 'react';

const FilesSubmittedSVG = ({
  color = 'black',
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='29'
      height='33'
      viewBox='0 0 29 33'
      fill='none'
      className={className}
    >
      <path
        d='M25.9706 17.25V8.7C25.9706 6.17976 25.9706 4.91964 25.4705 3.95705C25.0306 3.11031 24.3288 2.4219 23.4654 1.99047C22.4838 1.5 21.1991 1.5 18.6294 1.5H8.84118C6.27152 1.5 4.98669 1.5 4.00522 1.99047C3.14188 2.4219 2.43998 3.11031 2.00009 3.95705C1.5 4.91964 1.5 6.17976 1.5 8.7V24.3C1.5 26.8203 1.5 28.0803 2.00009 29.043C2.43998 29.8897 3.14188 30.5781 4.00522 31.0095C4.98669 31.5 6.27152 31.5 8.84118 31.5H13.7353M16.7941 15H7.61765M10.6765 21H7.61765M19.8529 9H7.61765M17.5588 27L20.6176 30L27.5 23.25'
        stroke='#0744E1'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FilesSubmittedSVG;
